module.exports = require("webpack/lib/SingleEntryPlugin");


//////////////////
// WEBPACK FOOTER
// external "webpack/lib/SingleEntryPlugin"
// module id = 82
// module chunks = 0